import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3558194b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "navigation"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-back" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-back" }, null, -1))
const _hoisted_6 = { class: "text bold" }
const _hoisted_7 = {
  key: 1,
  class: "d-navigation"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-back" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-back" }, null, -1))
const _hoisted_11 = { class: "text bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("p", {
          class: "text bold navigation__drive",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('drive')))
        }, _toDisplayString(_ctx.$localize('move.to.popup.navigation.title')), 1),
        (_ctx.showDots)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _createElementVNode("p", {
                class: "text bold navigation__dots",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back')))
              }, _toDisplayString(_ctx.$localize('move.to.popup.navigation.dots')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currentPosition)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.currentPosition), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", {
          class: "text navigation__drive",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('drive')))
        }, _toDisplayString(_ctx.$localize('move.to.popup.navigation.title')), 1),
        (_ctx.showDots)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_9,
              _createElementVNode("p", {
                class: "text bold navigation__dots",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('back')))
              }, _toDisplayString(_ctx.$localize('move.to.popup.navigation.dots')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currentPosition)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_10,
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.currentPosition), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]))
}